<template>
    <div>
        <div class="d-flex justify-content-center">
            <b-spinner large v-if="loading" class="mx-2" />
            <span v-if="loading">Loading...</span>
        </div>
        <b-card v-if="!loading">
            <b-form @submit.prevent="editRawMaterial" v-if="!loading">
                <b-row>
                    
                    <b-col md="6">
                        <b-form-group label="Raw Material Name*" label-for="mc-Raw Material-Supplier">
                            <b-form-input id="mc-Raw Material-Supplier" placeholder="Raw Material"
                                v-model="rawmaterialsID.name" readonly />
                        </b-form-group>
                    </b-col>
                    <b-col md="6">
                        <b-form-group label="Raw Material Code" label-for="mc-Raw Material-Code">
                            <b-form-input id="mc-Raw Material-Code" v-model="rawmaterialsID.code" readonly />
                        </b-form-group>
                    </b-col>
                    <b-col md="6">
                        <b-form-group label-for="mc-stock-threshold" label="Low Stock Threshold*">
                            <div class="form-label-group">
                                <b-form-input id="mc-stock" type="text" placeholder="Low Stock Threshold"
                                    v-model="rawmaterialsID.lowStock" readonly />
                            </div>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                        <b-form-group label="Category*" label-for="mc-Category" v-if="rawmaterialsID.category">
                            <b-form-input v-model="rawmaterialsID.category.name" placeholder="RMTest1" readonly />
                        </b-form-group>
                    </b-col>

                    <b-col cols="6">
                    <b-form-group label="Sub Category" label-for="mc-subCategory">
                    <b-form-input
                        id="mc-subCategory"
                        :value="
                        getSubCategoryNameById(rawmaterialsID.productCategorySubId)
                        "
                        readonly
                    />
                    </b-form-group>
                </b-col>

                    <b-col cols="6">
                        <b-form-group label="UOM" label-for="mc-Uom">
                            <b-form-input v-model="uomName" placeholder="Kg" readonly />
                        </b-form-group>

                    </b-col>
                    <b-col md="6">
                        <b-form-group label="Price (Rs)" label-for="Price (Rs)">
                            <b-form-input type="text" id="mc-Raw Material-Price" placeholder="Raw Material Price" v-if="HasPermission(PermissionList.Inventory_Finance)"
                                v-model="rawmaterialsID.purchasePrice" readonly />
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                        <b-form-group label="Preferred Supplier" label-for="mc-Supplier">

                            <b-form-select v-model="rawmaterialsID.supplierId" :options="suppliers" value-field="id"
                                text-field="name" disabled />
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" class="mb-2">
                        <label for="textarea-default">Raw Material Description</label>
                        <b-form-textarea id="textarea-default" rows="5" placeholder="Description"
                            v-model="rawmaterialsID.description" readonly />
                    </b-col>

                    <b-col class="12">

    
                        <CustomFieldsDetails :ReadOnlyFields=true :AdditionalFields="rawmaterialsID.additionalFields" :ModuleReference="'RawMaterial'" @onchange="additionalFieldChanges" />
                    </b-col>

                </b-row>
            </b-form>
        </b-card>
    </div>
</template>

<script>
import { BRow, BCol, BForm, BFormInput, BFormTextarea, BFormSelect, BFormDatepicker, BFormGroup,
    BCard, BButton, BSpinner } from 'bootstrap-vue'
import { mapActions, mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import { onBeforeMount } from '@vue/composition-api'
import CustomFieldsDetails from "@/views/component/CustomFieldsDetails.vue";
import { PermissionList } from "@/libs/defaultList";
import { HasPermission } from "@/@core/utils/validations/permissionCheck";

export default {
    name: 'EditRawMaterial',
    components: {
        BRow,
        BCol,
        BForm,
        BFormInput,
        BFormTextarea,
        BFormSelect,
        BFormDatepicker,
        BFormGroup,
        BButton,
        ValidationProvider,
        ValidationObserver,
        BSpinner,
        BCard,
        ///
        required,
        CustomFieldsDetails
    },

    data() {
        return {
            id: this.$route.params.id,
            uomName: '',
            optionsSalesPerson: [],
            optionsWarehouse: [],
            loading:true
        }
    },

    setup(props) {
    return {
      PermissionList,
      HasPermission,
    };
  },

    computed: {
        ...mapGetters("rawmaterialModule", {
            rawmaterialsID: "rawmaterialsID",
            loading: "loading"
        }),
        ...mapGetters("itemUomModule", {
            itemUoms: "itemuom",
            loading: "loading",
        }),
        ...mapGetters("itemcategoryModule", {
            itemCategories: "itemcategories",
            loading: "loading",
        }),
        ...mapGetters("rawmaterialModule", {
            loading: "loading",
        }),
        ...mapGetters("supplierModule", {
            suppliers: "suppliers",
            loading: "loading",
        }),
        ...mapGetters("salesPersonModule", {
            SalesPersonList: "salesperson",
            loading: "loading",
        }),
        ...mapGetters("warehouseModule", {
            warehouses: "warehouse",
            warehouseLoading: "loading",
        }),

    },
    methods: {

        ...mapActions("rawmaterialModule", ["addRawMaterialAction"]),
        ...mapActions("itemUomModule", ["getItemUOMListAction"]),
        ...mapActions("itemcategoryModule", ["getItemCategoryListAction"]),
        ...mapActions("supplierModule", ["getSupplierListAction"]),
        ...mapActions("salesPersonModule", ["getSalesPersonListAction"]),
        ...mapActions("warehouseModule", ["getWarehouseListAction"]),
        success() {
            this.$swal({
                title: 'rawmaterials updated!',
                text: 'You have successfully updated the rawmaterial!',
                icon: 'success',
                customClass: {
                    confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
            })
        },
        error() {
            this.$swal({
                title: 'Error!',
                text: ' Failed!',
                icon: 'error',
                customClass: {
                    confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
            })
        },
        ...mapActions("rawmaterialModule", [
            "getRawMaterialListByIdAction"
        ]),

        ...mapActions("itemUomModule", [
            "getItemUOMListAction"
        ]),
        editRawMaterial() {
            let payload = {
                id: this.id,
                name: this.name,
                description: this.description,
                categoryId: this.categoryId,
                code: this.code,
                lowStock: this.lowStock,
                defaultUomID: this.defaultUomID,
                purchasePrice: this.purchasePrice,
            }
            this.updateRawMaterialAction(payload)
                .then(() => {
                    this.success()
                })
                .catch(() => {
                    this.error()
                })
        },

        getSubCategoryNameById(id) {
      const category = this.itemCategories.find((item) => item.id === id);
      return category ? category.name : null;
    },
    },
    async mounted() {
        

        await this.getItemUOMListAction();
        await this.getRawMaterialListByIdAction(this.id);
        await this.getSupplierListAction();

        let uom = this.itemUoms.filter(obj => {
            return obj.id === this.rawmaterialsID.defaultUomID;
        });

        if (uom.length > 0) {
            this.uomName = uom[0].name;
        }

        await this.getSalesPersonListAction().then(() => {
            this.SalesPersonList.map((v, i) =>
                this.optionsSalesPerson.push({
                    value: v.id,
                    text: `${v.firstName}` + " " + `${v.lastName}`,
                })
            );
        });
        await this.getWarehouseListAction().then(() => {
            this.warehouses.map((v, i) =>
                this.optionsWarehouse.push({
                    value: v.id,
                    text: `${v.name}`,
                })
            );
        });

        this.loading = false;
    }
}
</script>
